import { useQuery } from '@tanstack/react-query';

import { TransferMatePayment } from 'src/features/payments/services/types';
import { BookingServiceEndpoints } from 'src/api/bookingService';
import { studentBookingClient } from 'src/api';
import { StudentBookingSuccessResponse } from 'src/api/types';

export const useGetAdvanceFeePayment = (bookingId: string) =>
    useQuery<TransferMatePayment>({
        queryKey: ['make-payment-advance-fee', bookingId],
        queryFn: async () => {
            const url = BookingServiceEndpoints.GetDataForTransfermatePayment.replace(
                '{bookingId}',
                bookingId
            );

            const { data } =
                await studentBookingClient.get<StudentBookingSuccessResponse<TransferMatePayment>>(
                    url
                );
            return data.data;
        },
        enabled: !!bookingId,
    });
